export const palette = {
  primary: {
    main: '#1A9E2A',
    light: '#D3F5D9',
    dark: '#0F561A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#5F8740',
    light: '#E3ECDB',
    dark: '#2F4220',
    contrastText: '#FFFFFF',
  },
  tertiary: {
    main: '#7E6849',
    light: '#EDE5DE',
    dark: '#3D3428',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#BA1A1A',
    light: '#FFDAD6',
    dark: '#690005',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#B45309',
    light: '#FEF3C7',
    dark: '#78350F',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#1A9E2A',
    light: '#D3F5D9',
    dark: '#0F561A',
    contrastText: '#FFFFFF',
  },
  background: {
    default: '#FBFDFB',
    paper: '#FBFDFB',
  },
  surface: {
    main: '#FBFDFB',
    variant: '#E1E8E1',
    containerLow: '#F4F7F4',
    container: '#EEF3EE',
    containerHigh: '#E8EDE8',
    containerHighest: '#E1E8E1',
  },
  text: {
    primary: '#191C19',
    secondary: '#444D44',
    disabled: '#758075',
  },
  divider: '#C5CFC5',
  outline: {
    main: '#758075',
    variant: '#C5CFC5',
  },
}

export const status = {
  critical: { color: '#BA1A1A', bg: '#FFDAD6' },
  warning: { color: '#B45309', bg: '#FEF3C7' },
  ok: { color: '#1A9E2A', bg: '#D3F5D9' },
  aboveMax: { color: '#7E6849', bg: '#EDE5DE' },
}

export const freshness = {
  fresh: { color: '#1A9E2A', label: '<24h' },
  aging: { color: '#B45309', label: '24-72h' },
  stale: { color: '#BA1A1A', label: '>72h' },
}

export const darkPalette = {
  primary: {
    main: '#AAEDB5',
    light: '#147A21',
    dark: '#D3F5D9',
    contrastText: '#0F561A',
  },
  secondary: {
    main: '#CADBBA',
    light: '#476430',
    dark: '#E3ECDB',
    contrastText: '#2F4220',
  },
  error: {
    main: '#FFB4AB',
    light: '#93000A',
    dark: '#FFDAD6',
    contrastText: '#690005',
  },
  background: {
    default: '#191C19',
    paper: '#191C19',
  },
  text: {
    primary: '#E1E8E1',
    secondary: '#C5CFC5',
    disabled: '#8F9A8F',
  },
  divider: '#444D44',
}
